(() => {
  'use strict';
  const route = /^(\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/flits-wishlist\/?$/i;
  const current = window.location.pathname.match(route);
  if (!current || document.documentElement.hasAttribute('data-am-wishlist-prices-bound')) return;
  document.documentElement.setAttribute('data-am-wishlist-prices-bound', '');
  const scope = '.flits_wishlist_page_container[data-flits-wishlist-page="true"]';
  const localeRoot = current[1] || '';
  const zh = (document.documentElement.lang || '').toLowerCase().startsWith('zh');
  let catalog = {currency:'USD', prices:{}};
  try {
    const parsed = JSON.parse(document.querySelector('[data-am-wishlist-prices]')?.textContent || '{}');
    if (/^[A-Z]{3}$/.test(parsed.currency) && parsed.prices && typeof parsed.prices === 'object') catalog = parsed;
  } catch (_) {}
  const money = new Intl.NumberFormat(zh ? 'zh-CN' : 'en-US', {minimumFractionDigits:0, maximumFractionDigits:2});
  const workFromLink = node => {
    const raw = node?.getAttribute('href');
    if (!raw || raw.length > 2048 || /[\u0000-\u0020\\]/.test(raw)) return null;
    try {
      const url = new URL(raw, window.location.href);
      if (url.origin !== window.location.origin || url.username || url.password || !/^https?:$/.test(url.protocol)) return null;
      const match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[a-z0-9-]+\/)?products\/([a-z0-9][a-z0-9-]{0,119})\/?$/i);
      return match ? {handle:match[1], url:new URL(localeRoot + '/products/' + match[1], window.location.origin).href} : null;
    } catch (_) { return null; }
  };
  let pending = false;
  const refresh = () => {
    if (!route.test(window.location.pathname)) return;
    for (const card of [...document.querySelectorAll(scope + ' .flits_wishlist_page_grid_item')].slice(0,250)) {
      const name = card.querySelector('.flits_wishlist_page_grid_product_name');
      const entry = workFromLink(name) || workFromLink(card.querySelector('.flits_wishlist_page_grid_image_link'));
      const info = card.querySelector('.flits_wishlist_page_grid_info');
      card.querySelectorAll('[data-am-wishlist-card-enquiry]').forEach(node => node.remove());
      if (!entry || !info) continue;
      let price = card.querySelector('[data-am-wishlist-retail-price]');
      const amount = catalog.prices[entry.handle];
      if (Number.isSafeInteger(amount) && amount > 0) {
        if (!price) { price=document.createElement('p'); price.className='amw-retail-price'; price.setAttribute('data-am-wishlist-retail-price',''); info.append(price); }
        const text = catalog.currency + ' ' + money.format(amount / 100);
        if (price.textContent !== text) price.textContent=text;
      } else price?.remove();
      let link = card.querySelector('[data-am-wishlist-card-view]');
      if (!link) { link=document.createElement('a'); link.className='amw-card-view'; link.setAttribute('data-am-wishlist-card-view',''); info.append(link); }
      if (link.href !== entry.url) link.href=entry.url;
      const label = zh ? '查看作品' : 'View work';
      if (link.textContent !== label) link.textContent=label;
      const aria = label + ': ' + (name?.textContent?.trim() || entry.handle);
      if (link.getAttribute('aria-label') !== aria) link.setAttribute('aria-label',aria);
    }
  };
  const schedule = () => {
    if (pending) return;
    pending=true;
    queueMicrotask(() => { pending=false; refresh(); });
  };
  const start = () => {
    if (!document.body) return;
    const observer=new MutationObserver(schedule);
    observer.observe(document.body,{childList:true,subtree:true});
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
